import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo.vue";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "title",
      description: "右侧内容部分title,可选",
      type: "String"
    },
    {
      prop: "mode",
      description: "模式：水平或者垂直",
      available: "horizontal、vertical",
      default: "horizontal",
      type: "String"
    },
    {
      prop: "label",
      description: "内部功能块标题，用于关联锚点",
      type: "String"
    },
    {
      prop: "labelRenderer",
      description: "用于自定义label的渲染函数",
      type: "Function"
    }
  ],
  events: [],
  methods: [],
  slots: [
    {
      name: "options",
      description: "在title有效时作为title右侧的操作区"
    },
    {
      name: "menuOptions",
      description: "menu区域填充区"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
